import { Injectable } from '@angular/core';
import { Pageable } from 'app/interfaces/Pageable/pageable';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  state = {
    filtro: this.defaultFiltro,
    data: {} as Pageable,
    page: 0,
  };

    get defaultFiltro() {
    return {
      nome: '',
      grpId: '',
      ativo: [true],
    };
  }

  constructor(
  ) { }

  destroy() {
    this.state = {
      filtro: this.defaultFiltro,
      data: {} as Pageable,
      page: 0,
    };
  }

   get filtro() {
    const filtro = {
      nome: this.state.filtro.nome,
      grpId: this.state.filtro.grpId,
      ativo: this.state.filtro.ativo,
    };
    return filtro;
  }

}
